import React from "react";
import { TIME_SLOTS, isSlotFull } from "./useBookingForm";
import type { BookingErrors, BookingFormState } from "./useBookingForm";
interface DateOption {
  value: string;
  weekday: string;
  day: string;
  month: string;
}
interface StepProps {
  form: BookingFormState;
  errors: BookingErrors;
  update: <K extends keyof BookingFormState>(key: K, value: BookingFormState[K]) => void;
  dates: DateOption[];
}
export function BookingScheduleStep({
  form,
  errors,
  update,
  dates
}: StepProps) {
  return <div className="space-y-7" data-id="element-130" data-mp="3hl03umv7iqqt">
      <fieldset data-id="element-131" data-mp="3hl9wyjbjte0q">
        <legend className="text-sm font-semibold text-ink" data-id="element-132" data-mp="3hhm1hemjmhjd">Tanggal</legend>
        <div className="-mx-6 mt-3 flex gap-2 overflow-x-auto px-6 pb-1" data-id="element-133" data-mp="33ls51v2yhkn5">
          {dates.map(d => {
          const active = form.date === d.value;
          return <button key={d.value} type="button" onClick={() => update("date", d.value)} aria-pressed={active} aria-label={`${d.weekday} ${d.day} ${d.month}`} className={`flex w-16 shrink-0 flex-col items-center rounded-card py-3 ring-1 transition-[background-color,color,box-shadow] duration-150 ${active ? "bg-espresso text-cream ring-espresso" : "bg-white text-ink ring-cream-line hover:ring-sage"}`} data-id="element-134" data-mp="11u5j47xx8fxj">
                <span className={`whitespace-nowrap text-[11px] ${active ? "text-cream/70" : "text-ink-muted"}`} data-id="element-135" data-mp="sn6g9h5ywg0w">
                  {d.weekday}
                </span>
                <span className="mt-1 text-lg font-semibold" data-id="element-136" data-mp="12k1gq5lswqht">{d.day}</span>
                <span className={`text-xs ${active ? "text-cream/70" : "text-ink-muted"}`} data-id="element-137" data-mp="12i89op7a049a">{d.month}</span>
              </button>;
        })}
        </div>
        {errors.date && <p className="mt-2 text-xs text-[#B5543A]" data-id="element-138" data-mp="2dxn3xl83oi0p">{errors.date}</p>}
      </fieldset>

      <fieldset disabled={!form.date} data-id="element-139" data-mp="28zvc0r7ggvwi">
        <legend className="text-sm font-semibold text-ink" data-id="element-140" data-mp="2g3leb27tsalj">Jam</legend>
        {!form.date && <p className="mt-1 text-xs text-ink-muted" data-id="element-141" data-mp="2g5o4pncw45qs">Pilih tanggal untuk melihat ketersediaan.</p>}
        <div className="mt-3 grid grid-cols-3 gap-2" data-id="element-142" data-mp="2l4r7f15edzvl">
          {TIME_SLOTS.map(t => {
          const full = isSlotFull(form.date, t);
          const active = form.time === t;
          return <button key={t} type="button" disabled={!form.date || full} onClick={() => update("time", t)} aria-pressed={active} className={`rounded-card py-3 text-sm font-medium ring-1 transition-[background-color,color,box-shadow] duration-150 disabled:cursor-not-allowed ${active ? "bg-sage text-cream ring-sage" : full ? "bg-transparent text-ink-muted/60 line-through ring-cream-line" : "bg-white text-ink ring-cream-line hover:ring-sage disabled:opacity-50"}`} data-id="element-143" data-mp="2uyht5ya53w7l">
                {t}
                {full && <span className="sr-only" data-id="element-144" data-mp="3sttwxdoyfodd"> (penuh)</span>}
              </button>;
        })}
        </div>
        {errors.time && <p className="mt-2 text-xs text-[#B5543A]" data-id="element-145" data-mp="3ntz7zfoqp8uy">{errors.time}</p>}
      </fieldset>
    </div>;
}